import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconArrowsExchange,
  IconBuildingBank,
  IconBuildingWarehouse,
  IconCashBanknote,
  IconCoin,
  IconBan,
  IconWallet,
} from '@tabler/icons-react'

export const walletModuleKey = 'business_partner_list'
// Wallet transactions got its own backend permission module, separate from the
// business-partner wallet list — the section is hidden unless this is granted.
export const walletTransactionsModuleKey = 'wallet_transaction'
// Point (ball) transactions have their own backend permission module, separate
// from wallet transactions — the section is hidden unless this is granted.
export const cashbackTransactionsModuleKey = 'cashback_transaction'
export const payDebtModuleKey = 'pay_debts'
export const debtLimitModuleKey = 'set_debt_limit'
export const debtorsByWarehouseModuleKey = 'debtors_by_warehouse'
// Backend permission module for the warehouse debt limits page.
export const warehouseDebtsModuleKey = 'warehouse_debts'

const walletRoute: RouteConfig = {
  uid: walletModuleKey,
  path: 'wallet',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/wallet')).default,
  }),
}

const walletDetailRoute: RouteConfig = {
  uid: walletModuleKey,
  path: 'wallet/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/wallet/wallet-detail')).default,
  }),
}

const walletTransactionsRoute: RouteConfig = {
  uid: walletTransactionsModuleKey,
  path: 'wallet-transactions',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/wallet/transactions')).default,
  }),
}

const cashbackTransactionsRoute: RouteConfig = {
  uid: cashbackTransactionsModuleKey,
  path: 'cashback-transactions',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/cashback/transactions')).default,
  }),
}

const payDebtRoute: RouteConfig = {
  uid: payDebtModuleKey,
  path: 'debt/pay-debt',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/debt/pay-debt')).default,
  }),
}

const debtLimitRoute: RouteConfig = {
  uid: payDebtModuleKey,
  path: 'debt/debt-limit',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/debt/debt-limit')).default,
  }),
}

const debtorsByWarehouseRoute: RouteConfig = {
  uid: debtorsByWarehouseModuleKey,
  path: 'wallet/debtors-by-warehouse',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/wallet/debtors-by-warehouse')).default,
  }),
}

const warehouseDebtLimitsRoute: RouteConfig = {
  uid: warehouseDebtsModuleKey,
  path: 'debt/warehouse-debt-limits',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/debt/warehouse-debt-limits')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'debt_wallet',
  href: 'debt-wallet',
  icon: <IconWallet size={18} />,
  order: 10,
  sub: [
    {
      uid: walletModuleKey,
      title: 'Wallet',
      href: '/wallet',
      icon: <IconWallet size={18} />,
      order: 1,
    },
    {
      uid: payDebtModuleKey,
      title: 'pay_debt',
      href: '/debt/pay-debt',
      icon: <IconCashBanknote size={18} />,
      order: 2,
    },
    {
      uid: debtLimitModuleKey,
      title: 'debt limit',
      href: '/debt/debt-limit',
      icon: <IconBan size={18} />,
      order: 3,
    },
    {
      uid: debtorsByWarehouseModuleKey,
      title: 'debtors_by_warehouse',
      href: '/wallet/debtors-by-warehouse',
      icon: <IconBuildingWarehouse size={18} />,
      order: 4,
    },
    {
      uid: warehouseDebtsModuleKey,
      title: 'warehouse_debt_limits',
      href: '/debt/warehouse-debt-limits',
      icon: <IconBuildingBank size={18} />,
      order: 5,
    },
    {
      uid: walletTransactionsModuleKey,
      title: 'wallet_transactions',
      href: '/wallet-transactions',
      icon: <IconArrowsExchange size={18} />,
      order: 6,
    },
    {
      uid: cashbackTransactionsModuleKey,
      title: 'cashback_transactions',
      href: '/cashback-transactions',
      icon: <IconCoin size={18} />,
      order: 7,
    },
  ],
}

export default [
  walletRoute,
  walletTransactionsRoute,
  cashbackTransactionsRoute,
  walletDetailRoute,
  payDebtRoute,
  debtLimitRoute,
  debtorsByWarehouseRoute,
  warehouseDebtLimitsRoute,
]
